import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { Box } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';
import { useMeasure } from 'react-use';
import { DashboardFeedList } from './DashboardFeedList';
import { DashboardFeedSummary } from './DashboardFeedSummary';
import { ResizeDashboardFeedList } from './ResizeDashboardFeedList';

interface DashboardFeedAnalysisContentProps {
  analysis: AnalysisViewFragment;
  shouldDisableInteraction?: boolean;
}

export function DashboardFeedAnalysisContent({
  analysis,
}: DashboardFeedAnalysisContentProps) {
  const [conatinerRef, { width: containerWidth }] = useMeasure();

  const shouldShowAsFeed = useDashboardStore(
    ({ metadata }) =>
      metadata.analysesMetadata.find((metadata) => metadata.id === analysis.id)
        ?.shouldShowAsFeed,
  );

  if (shouldShowAsFeed) {
    return (
      <Box ref={conatinerRef} sx={{ width: '100%', height: '100%' }}>
        {containerWidth < 400 ? (
          <ResizeDashboardFeedList analysis={analysis} />
        ) : (
          <DashboardFeedList analysis={analysis} />
        )}
      </Box>
    );
  }

  return <DashboardFeedSummary analysis={analysis} />;
}
